import { SkeletonBlock } from './SkeletonBlock';

export const SidebarHeaderSkeleton = () => {
  return (
    <div className="w-full flex flex-col justify-start items-center relative">
      <div className="w-64 h-14 px-4 py-5 bg-black/60 inline-flex justify-start items-center gap-2">
        <div className="flex-1 flex justify-start items-center gap-2">
          <SkeletonBlock className="size-6 rounded-lg" />
          <div className="flex-1 flex items-center gap-1.5">
            <SkeletonBlock className="h-3.5 w-20 rounded" />
            <SkeletonBlock className="size-4 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
};
